import React from 'react'
import CollegeFootball from 'src/components/page/college-football'
import { teamIds } from 'src/constants/personalizationIds'
export default (props) => (
  <CollegeFootball
    {...props}
    team="USC Trojans"
    subtitle="See the USC Trojans in action this season"
    hasGenericVideo={true}
    teamId={teamIds['USC Trojans']}
    poster="https://assets-imgx.fubo.tv/marketing/lp/images/posters/CFB/Trojans.png"
  />
)
